/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const CHECK = 'CHECK'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const GROUP_VIEW = 'GROUP_VIEW'
export const CHECK_GROUP_VIEW = 'CHECK_GROUP_VIEW'

export default {
  CHECK,
  LOGIN,
  LOGOUT,
  GROUP_VIEW,
  CHECK_GROUP_VIEW,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js